import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import PromptsTab from "../components/AdminComponents/PromptsTab";
import UserRecordsTab from "../components/AdminComponents/UserRecordsTab";

import "../styles/dashbaords.scss";

const AdminDashboard = () => (
    <div className="container mt-4">
        <Row className="mb-4">
            <Col><h2>Admin Dashboard</h2></Col>
        </Row>
        <Tabs defaultActiveKey="prompts" className="mb-3">
            <Tab eventKey="prompts" title="Prompts" mountOnEnter>
                <PromptsTab />
            </Tab>
            <Tab eventKey="podcasters" title="Podcasters" mountOnEnter>
                <UserRecordsTab endpoint="/admin/podcasters" label="Podcaster" />
            </Tab>
            <Tab eventKey="listeners" title="Listeners" mountOnEnter>
                <UserRecordsTab endpoint="/admin/listeners" label="Listener" />
            </Tab>
        </Tabs>
    </div>
);

export default AdminDashboard;
